import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

//constants
import { Constants }         from '../../constants/Constants';

//components
import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {GeneralDetailsComponent} from '../../components/ControlGroups/GeneralDetails.component';
import {CustomerRequirementsComponent} from '../../components/ControlGroups/CustomerRequirements.component';
import {AddressComponent} from '../../components/ControlGroups/Address.component';
import {ContactDetailsComponent} from '../../components/ControlGroups/ContactDetails.component';
import {SalesAndDeliveryDetailsComponent} from '../../components/ControlGroups/SalesAndDeliveryDetails.component';
import {CoolerDetailsComponent} from '../../components/ControlGroups/CoolerDetails.component';
import {FountainDetailsComponent} from '../../components/ControlGroups/FountainDetails.component';
import {VendorDetailsComponent} from '../../components/ControlGroups/VendorDetails.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';
import BaseNewOutletRequestComponent from 'src/app/baseclasses/BaseNewOutletRequest.component';

@Component({
  selector: 'my-createequipmentonly-request',
  templateUrl: './CreateEquipmentOnlyRequest.component.html'
})
export class CreateEquipmentOnlyRequestComponent extends BaseNewOutletRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(CustomerRequirementsComponent) customerRequirementsComponent: CustomerRequirementsComponent;
    @ViewChild(AddressComponent) addressComponent: AddressComponent;
    @ViewChild(ContactDetailsComponent) contactDetailsComponent: ContactDetailsComponent;
    @ViewChild(SalesAndDeliveryDetailsComponent) salesAndDeliveryDetailsComponent: SalesAndDeliveryDetailsComponent;
    @ViewChild(CoolerDetailsComponent) coolerDetailsComponent: CoolerDetailsComponent;
    @ViewChild(FountainDetailsComponent) fountainDetailsComponent: FountainDetailsComponent;
    @ViewChild(VendorDetailsComponent) vendorDetailsComponent: VendorDetailsComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;

    showEquipmentInstallSections: boolean;
    showCustomerRequirements: boolean;
    constructor() 
    {
        super();
    }


    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
              this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
    }

    ngAfterViewInit() {
        super.subscribeToOverallAccountCopyMethodsInContactDetailsSection();
        super.subscribeToOverallAccountCopyMethodsInBillingAddressSection();
        super.ngAfterViewInit();
        
    }

    onSaveClick(event: any){
        
        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.EquipmentOnlyCustomer,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            ContactInfos: this.contactDetailsComponent.contactGridComponent.records,
            OtherInfo: this.notesComponent.otherInfo,
            SalesAndDeliveryInfo: this.salesAndDeliveryDetailsComponent.salesAndDeliveryInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: this.userInfoComponent.userInfo.SalesOffice.ID, 
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);

        this.requestToSave.GeneralInfo.BusinessTypeID = enums.BusinessTypeEnum.EquipmentOnly;
        if (this.generalDetailsComponent.generalInfo.IncludeSurveyRequest || this.generalDetailsComponent.generalInfo.IncludeEquipmentInstall)
        {
            this.requestToSave.CustomerRequirementInfo = this.customerRequirementsComponent.customerRequirementInfo;
            this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.customerRequirementsComponent.dayOfWeekMultiSelectComponent, enums.DayType.CustomerNotAvailable);

            this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityStartString = this.customerRequirementsComponent.getStartTime();
            this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityEndString = this.customerRequirementsComponent.getEndTime();

            if (this.generalDetailsComponent.generalInfo.IncludeSurveyRequest) {
                this.requestToSave.RequestEquipmentClasses = util.RequestUtil.LoadRequestEquipmentClasses(this.requestToSave, this.customerRequirementsComponent.equipmentClassMultiSelectComponent);
            }
            else {
                this.requestToSave.VendorLineItems = this.vendorDetailsComponent.vendorLineItemGrid.lineItems;
                this.requestToSave.FountainLineItems = this.fountainDetailsComponent.fountainLineItemGrid.lineItems;
                this.requestToSave.CoolerLineItems = this.coolerDetailsComponent.coolerLineItemGrid.lineItems;

                this.requestToSave.CoolerInfo = this.coolerDetailsComponent.coolerInfo;
                this.requestToSave.FountainInfo = this.fountainDetailsComponent.fountainInfo;
                this.requestToSave.FountainInfo.Flavors = this.fountainDetailsComponent.getFlavors();
                this.requestToSave.VendorInfo = this.vendorDetailsComponent.vendorInfo;
            }
            this.requestToSave.VendorInfo.EquipmentLocations = this.vendorDetailsComponent.equipmentLocationsComponent.getEquipmentLocations();
        }

        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        this.requestToSave.Addresses = [];
        if (util.AddressUtil.isAddressPopulated(this.addressComponent.address)){
            this.requestToSave.Addresses.push(this.addressComponent.address);
        }

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);

    }
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

    onIncludeEquipmentInstallChanged(checked: boolean){
        this.showEquipmentInstallSections = checked;
        this.showCustomerRequirements = checked || this.generalDetailsComponent.generalInfo.IncludeSurveyRequest;
        this.customerRequirementsComponent.showRequestedInstallDate = checked;
        this.customerRequirementsComponent.requireRequestedInstallDate = checked;
        this.customerRequirementsComponent.showEquipmentClass = this.generalDetailsComponent.generalInfo.IncludeSurveyRequest;
        this.customerRequirementsComponent.updateValidators();
    }

    onIncludeSurveyRequestChanged(checked: boolean){
        this.showCustomerRequirements = checked || this.generalDetailsComponent.generalInfo.IncludeEquipmentInstall;
        this.customerRequirementsComponent.showRequestedSurveyDate = checked;
        this.customerRequirementsComponent.requireRequestedSurveyDate = checked;
        this.customerRequirementsComponent.showEquipmentClass = checked;
        this.customerRequirementsComponent.updateValidators();
    }

}